import { render } from "./editStuff.vue?vue&type=template&id=92b4411c"
import script from "./editStuff.vue?vue&type=script&lang=js"
export * from "./editStuff.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__